import React from 'react';

function TextAlignLeft({ size }) {
  return (
    <svg height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 6H3V7.5H21V6Z" fill="black" />
      <path d="M15 9.75H3V11.25H15V9.75Z" fill="black" />
      <path d="M15 17.25H3V18.75H15V17.25Z" fill="black" />
      <path d="M21 13.5H3V15H21V13.5Z" fill="black" />
    </svg>
  );
}

export default TextAlignLeft;
